import { type ClientContext, ContextClient } from '~/services/contextClient';
import BlastForecastClientFactory from './blastForecastClient.factory';
import {
    type BlastForecastClientInterface,
    type GetBlastForecastRequest,
    type AdjustCampaignRequest,
} from './blastForecastClient.types';

class BlastForecastClient extends ContextClient<BlastForecastClientInterface> {
    constructor() {
        super(BlastForecastClientFactory);
    }

    getBlastForecastSummary(context: ClientContext, params: GetBlastForecastRequest) {
        const client = this.getClient(context);
        return client.getBlastForecastSummary(params);
    }

    getBlastForecastCampaigns(context: ClientContext, params: GetBlastForecastRequest) {
        const client = this.getClient(context);
        return client.getBlastForecastCampaigns(params);
    }

    adjustCampaign(context: ClientContext, campaignId: number, payload: AdjustCampaignRequest) {
        const client = this.getClient(context);
        if (!client.adjustCampaign) {
            throw new Error(`adjustCampaign not supported by ${client.constructor.name}`);
        }
        return client.adjustCampaign(campaignId, payload);
    }

    getCampaign(context: ClientContext, campaignId: number) {
        const client = this.getClient(context);
        if (!client.getCampaign) {
            throw new Error(`getCampaign not supported by ${client.constructor.name}`);
        }
        return client.getCampaign(campaignId);
    }

    deleteCampaign(context: ClientContext, campaignId: number) {
        const client = this.getClient(context);
        if (!client.deleteCampaign) {
            throw new Error(`deleteCampaign not supported by ${client.constructor.name}`);
        }
        return client.deleteCampaign(campaignId);
    }
}

export default new BlastForecastClient();
